import React from 'react';
import AddressDisplay from './AddressDisplay.jsx';
import MediaControls from './MediaControls.jsx';
import SessionControlPanel from './SessionControlPanel.jsx';

/**
 * Vue GPS seule (pas de média).
 * Timeline maître + boutons, PAS de volume, PAS de MediaIndicator.
 */
const GpsMapDisplay = ({ refs, address, viewState, timelineState, mediaHandlers, sessionData, isHistoricalMode, canGoLive }) => (
  <div
    id="gps-map-display-section"
    ref={refs.gpsMapDisplaySection}
    className="display-mode-section"
    style={{ display: viewState?.gpsMapSection ? 'flex' : 'none' }}
  >
    <div
      id="map-container-gps"
      ref={refs.mapContainerGps}
      className="map-container"
      style={{ position: 'relative' }}
    >
      <AddressDisplay addressRef={refs.addressDisplayGps} text={address} />
      <SessionControlPanel sessionData={sessionData} isHistoricalMode={isHistoricalMode} />
    </div>
    <div id="gps-controls-container" style={{ width: '100%' }}>
      <MediaControls
        timelineState={timelineState}
        onPlay={mediaHandlers?.onPlay}
        onPause={mediaHandlers?.onPause}
        onStart={mediaHandlers?.onStart}
        onGoLive={mediaHandlers?.onGoLive}
        canGoLive={canGoLive}
        onTimelineInput={mediaHandlers?.onTimelineInput}
        onTimelineChange={mediaHandlers?.onTimelineChange}
        idPrefix="gps-"
      />
    </div>
  </div>
);

export default GpsMapDisplay;
